import React from 'react'

const CotizadorFres = () => {
  return (
    <div>CotizadorFres</div>
  )
}

export default CotizadorFres